var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtTooltipOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 8A4.668 4.668 0 0 0 8 3.333 4.668 4.668 0 0 0 3.333 8 4.668 4.668 0 0 0 8 12.667 4.668 4.668 0 0 0 12.667 8zm-8.4 0A3.735 3.735 0 0 1 8 4.267 3.735 3.735 0 0 1 11.734 8 3.735 3.735 0 0 1 8 11.733 3.735 3.735 0 0 1 4.267 8zM8 9.867a.467.467 0 1 1 0 .933.467.467 0 0 1 0-.933zm.285-4.648A1.868 1.868 0 0 0 6.218 6.52a.423.423 0 0 0 .406.546h.093c.191 0 .345-.136.41-.313a.934.934 0 0 1 1.074-.597c.443.093.77.527.733.98-.028.368-.286.567-.572.787-.2.153-.413.317-.572.557l-.002.004-.002.005a.104.104 0 0 1-.007.012 1.555 1.555 0 0 0-.124.245c-.002.007-.006.013-.01.018l-.009.019c-.002.005-.004.01-.005.017a1.735 1.735 0 0 0-.098.6h.934c0-.197.051-.36.13-.5l.012-.021a1.287 1.287 0 0 1 .142-.203l.008-.01c.002-.003.004-.007.007-.009.046-.056.098-.107.154-.159.07-.066.142-.13.216-.194.402-.35.819-.714.712-1.467-.112-.812-.751-1.498-1.563-1.62z",
    fill: "#424A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtTooltipOutline);
export default __webpack_public_path__ + "static/media/art-tooltip-outline.da2e225562c8e3fbae3d2422de95e54b.svg";
export { ForwardRef as ReactComponent };